import { PropsWithChildren } from 'react'
import { WithClassName } from 'shared/types/general.types'
import { cn } from 'utils/style'

type CardWrapperProps = WithClassName<PropsWithChildren>

export const CardWrapper = ({ children, className }: CardWrapperProps) => {
	return (
		<div className={cn('rounded-lg border border-border bg-card shadow-panel', className)}>
			{children}
		</div>
	)
}
